export default __webpack_public_path__ + "images/e9f1f2274ee25a9aade7061534684cc8-county_government.webp";